import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { OwnProps } from './index';
import { selectFertilizerWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (state: AppState, props: OwnProps): ProductId =>
    props.productId;

const selectProductRatePerArea = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'unitsPerArea'])
);

const makeSelectProductRatePerArea = (): typeof selectProductRatePerArea =>
    selectProductRatePerArea;

const selectProductUnitType = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [
            productId,
            'fertilizerProduct',
            'unitType',
            'name'
        ])
);

const makeSelectProductUnitType = (): typeof selectProductUnitType =>
    selectProductUnitType;

export {
    selectProductId,
    makeSelectProductRatePerArea,
    makeSelectProductUnitType
};
